"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboxSettingsLazyComponent = void 0;
var components_1 = require("./components");
var bmUtils_1 = require("./services/bmUtils");
exports.InboxSettingsLazyComponent = bmUtils_1.createLazyComponent({
    componentName: components_1.inboxSettingsComponentName,
    bundleFile: 'inbox-settings',
});
//# sourceMappingURL=lazy-component.js.map